module.exports = __webpack_public_path__ + "images/emoji/first_quarter_moon.5c38dfd0498dddafa5d4.png";